import type { HomeworkAssignmentSnapshot } from '@wx-weiqi/contracts';
import { latestHomeworkSubmissionForProblem } from './homework-grading';

/** Mirrors retry eligibility only; the server still owns deadlines and authorization. */
export function canAnswerHomeworkProblem(
  assignment: HomeworkAssignmentSnapshot,
  problemId: string,
): boolean {
  if (!assignment.items.some((item) => item.problem.problemId === problemId)) return false;
  const latest = latestHomeworkSubmissionForProblem(assignment, problemId);
  return (
    latest === null ||
    (assignment.answerMode === 'AUTOMATIC' &&
      latest.status === 'INCORRECT' &&
      (latest.elapsedMs ?? 0) < assignment.timeLimitSeconds * 1000 &&
      latest.attempt < assignment.maxAttempts)
  );
}

export function nextProblemIndex(
  assignment: HomeworkAssignmentSnapshot,
  startAt = 0,
): number | null {
  for (let offset = 0; offset < assignment.items.length; offset += 1) {
    const index = (startAt + offset) % assignment.items.length;
    const problemId = assignment.items[index]?.problem.problemId;
    if (problemId !== undefined && canAnswerHomeworkProblem(assignment, problemId)) return index;
  }
  return null;
}
